export function WordsBan(word){
    if (word.length>16){
        return "length";
    }
    const ban_words = [
        'ниггер',      'нига',          'нага',
        "niger","niga",
        'пидор',       'пидорас',       'педик',
        'гомик',       'петух',         'хохол',
        'хач',         'жид',           'хиджаб',
        'даун',        'аутист',        'дебил',
        'девственник', 'имп',           'инцел',
        'пизда',       'куколд',        'белый',
        'натурал',     'гетеросексуал', 'nigger',
        'nigga',       'naga',          'faggot',
        'retard',      'virgin',        'simp',
        'incel',       'c',             'cunt',
        "bot","bots","pidor","hohol","xoxol","пидарас"
    ]
    const value = word.toLowerCase(); // Приведем логин к нижнему регистру для сравнения
    const containsForbiddenWord = ban_words.some((word) => value.includes(word.toLowerCase()));
    if (containsForbiddenWord){
        return "ban_word"
    }
    return "ok"

}